import { IHttpClient } from '../../services/HttpClient/IHttpClient';
import {
  GetDataLakeFeedbacksRequest,
  GetDLFeedbacksResponse,
  GetFeedbacksRequest,
  GetFeedbacksResponse,
  GetFeedbacksStatsRequest,
  GetFeedbacksStatsResponse,
} from './feedback.models';
import { IFeedbackApi } from './IFeedbackApi';

export class FeedbackApi implements IFeedbackApi {
  constructor(private readonly httpClient: IHttpClient) {}

  public readonly getFeedbacks = async ({
    teamId,
    ...params
  }: GetFeedbacksRequest) => {
    const res = await this.httpClient.get<GetFeedbacksResponse>(
      `/core/feedback/team/${teamId}`,
      {
        isAuthorized: true,
        params: {
          ...params,
        },
      }
    );

    return res.items;
  };

  public readonly getDataLakeFeedbacks = async ({
    companyId,
    anonymous,
    from,
    to,
    teamId,
    userId,
    cursor,
    limit = 10,
    feedbackValue,
  }: GetDataLakeFeedbacksRequest) => {
    const res = await this.httpClient.get<GetDLFeedbacksResponse>(
      `/core/feedback/v2/list/${companyId}`,
      {
        isAuthorized: true,
        params: {
          anonymous: anonymous.toString(),
          from,
          to,
          teamId,
          userId,
          cursor,
          limit: limit.toString(),
          feedbackValue: feedbackValue ? `${feedbackValue}` : undefined,
        },
      }
    );

    return res;
  };

  public readonly getCompanyStats = async (req: GetFeedbacksStatsRequest) => {
    const res = await this.httpClient.get<GetFeedbacksStatsResponse>(
      `/core/feedback/stats/${req.companyId}`,
      {
        isAuthorized: true,
        params: {
          from: req.from,
          to: req.to,
          entity: req.entity,
          entityId: req.entityId,
        },
      }
    );
    return res.item;
  };
}
